import { clearAwinCookiesForInternalSite } from "@/utils/awin";

/**
 * Redirects to checkout URL after clearing Awin cookies on internal sites.
 * Use this helper instead of direct window.location.href for checkout redirects
 * to ensure cookies are cleared before navigation.
 *
 * @param checkoutUrl - The Shopify checkout URL to redirect to
 */
export const redirectToCheckout = (checkoutUrl: string): void => {
  if (typeof window === "undefined") {
    return;
  }

  // Clear Awin cookies before redirecting
  clearAwinCookiesForInternalSite();

  // Redirect to checkout
  window.location.href = checkoutUrl;
};
